import React from "react";
import { Div } from "components/Base";
import { connect } from "react-redux";
import * as PortalSelectors from "redux/modules/portal/selectors";

const decorate = connect(
  state => ({
    portal: PortalSelectors.portal(state)
  }),
  {}
);

const Footer = ({ portal }) => {
  const { id = null } = portal;
  return (
    <Div>
      <a
        style={{
          alignItems: "center",
          borderRadius: "2px",
          color: "#787878",
          display: "flex",
          fontStyle: "italic",
          fontWeight: 600,
          justifyContent: "center",
          margin: "50px auto 0",
          padding: "7px",
          textDecoration: "none"
        }}
        href={`https://www.sessionboard.com/?source=portal_login&portal_id=${id}`}
        rel="noopener noreferrer"
        target="_blank"
      >
        <img
          src="https://d2ams66j58uyd5.cloudfront.net/images/powered-by-sessionboard-gray.png"
          style={{
            height: "51px",
            width: "100px"
          }}
          alt=""
        />
      </a>
    </Div>
  );
};
export default decorate(Footer);
